// src/pages/About.jsx
import React from "react";

export default function About() {
  return (
    <main className="page">
      <div className="container">
        {/* Top header */}
        <div className="page-header">
          <div>
            <h1>About Platinum Palm Properties</h1>
            <p>
              A husband-and-wife brokerage built for sellers, buyers,
              investors, and families who want clear numbers and a calm
              process from start to finish.
            </p>
          </div>
          <div className="page-note">
            Licensed Florida real estate brokerage serving buyers, sellers,
            and investors along the Gulf Coast since <strong>2017</strong>.
          </div>
        </div>

        {/* Two-column layout */}
        <div className="about-grid">
          {/* Story / brokerage side */}
          <section className="card about-card">
            <h2>Our story</h2>
            <p>
              We started our real estate careers in <strong>2017</strong> inside two of the biggest
              brands in the industry: <strong>Keller Williams</strong> and{" "}
              <strong>eXp Realty</strong>. Those years gave us a front-row seat
              to what works, what doesn&apos;t, and how overwhelming the
              process can feel when you&apos;re not getting clear guidance.
            </p>
            <p>
              In <strong>2022</strong> we decided to open our own boutique
              brokerage so we could do things differently: fewer clients at a
              time, more intention behind every listing, and a genuine
              partnership with the people we represent.
            </p>
            <p>
              We&apos;ve earned multiple production awards and have
              been recognized in the <strong>top 1%</strong> of agents in our
              market, not because we chase volume, but because we
              obsess over doing excellent work for the right people.
            </p>

            <ul>
              <li>Husband-and-wife broker-owners, not a franchise</li>
              <li>Former top producers at Keller Williams &amp; eXp</li>
              <li>Serving Florida buyers, sellers &amp; investors since 2017</li>
              <li>Multiple awards recognizing top 1% production</li>
            </ul>
          </section>

          {/* Family / homestead side */}
          <aside className="card about-card about-family-card">
            <h2>About us</h2>
            <div className="about-family-image-wrap">
              <img
                src="/assets/about-family.jpg"
                alt="Our family on our 10-acre homestead"
                className="about-family-image"
              />
            </div>
            <p>
              When we&apos;re not negotiating contracts or walking properties,
              we&apos;re raising our family on a <strong>10-acre homestead
              farm</strong>. That balance keeps us grounded and reminds us that
              real estate isn&apos;t just about houses&mdash;it&apos;s about
              the life you&aposre building inside them.
            </p>
            <p>
              We take our business seriously because we know every move you make
              impacts your family, your financial future, and your peace of
              mind. You&apos;ll feel that in how we communicate, how we market
              your home, and how we fight for you at the negotiation table.
            </p>
            <p className="about-family-caption">
              Real people. Real family. Real estate done with intention.
            </p>
          </aside>
        </div>
      </div>
    </main>
  );
}
